import { ReactElement } from "react";
import ReactPlayer from "react-player/lazy";
import "./Player.scss";

const Player = ({
  media,
  title,
  className,
}: {
  media?: string;
  title: string;
  className?: string;
}): ReactElement => (
  <div className="react-player-container">
    {title && <label className="form__form-group-label">{title}</label>}
    <ReactPlayer controls muted loop playing={false} playsinline url={media} />
  </div>
);

export default Player;
